import { Injectable } from '@angular/core';
import { RequesterConstants } from '../constants/user-constants/requester.constants';
import { VIEW_TYPE } from '../constants/view-type.enum';
import { RequestResponse } from '../models/request-response.model';
import { RequesterTableColumns } from '../models/table-columns/requester-table-columns.model';

@Injectable({
    providedIn: 'root'
})
export class RequesterService {
    newRequestsView = VIEW_TYPE.NEW_REQUESTS;
    returnedRequestsView = VIEW_TYPE.RETURNED_REQUESTS;
    requestsAssignedToMeView = VIEW_TYPE.ASSIGNED_TO_ME_REQUESTS;
    requestsInProgressView = VIEW_TYPE.INPROGRESS_REQUESTS;
    completedRequestsView = VIEW_TYPE.COMPLETED_REQUESTS;

    constructor() {}

    convertResponseToTableData(viewType: string, response: RequestResponse) {
        
        if (viewType === this.requestsInProgressView ) 
        {
            return new RequesterTableColumns(response.id, response.service.name, response.createdAt);
        }
            else if( viewType === this.completedRequestsView){
                return new RequesterTableColumns(response.id, response.service.name, response.createdAt,response.icClosedAt);

            }
     else {
            return undefined;
        }
    }

    getTableColumns(requestObjectName: string) {
        return RequesterConstants[requestObjectName].tableColumn;
    }

    getTableHeaders(requestObjectName: string) {
        const displayColumns = RequesterConstants[requestObjectName].tableColumn.map(c => c.columnDef);

        const tableWithSelection = RequesterConstants[requestObjectName].tableWithSelection;
        if (tableWithSelection) {
            displayColumns.unshift('select');
        }

        return displayColumns;
    }

    isTableWithSelection(requestObjectName: string) {
        return RequesterConstants[requestObjectName].tableWithSelection;
    }

    getSideMenu() {
        const list = [RequesterConstants.INPROGRESS_REQUESTS, RequesterConstants.COMPLETED_REQUESTS];
        let sideMenuList = [];
        list.forEach(element => {
            sideMenuList.push(element);
        });

        return sideMenuList;
    }
}
